var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component.video)?_c('div',{ref:"player",staticClass:"ratio ratio-16x9"},[(!_vm.ready)?_c('div',{staticClass:"d-flex justify-content-center align-items-center w-100 h-100"},[_vm._m(0)]):_vm._e()]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }